import styled, { css } from 'styled-components'
import { Flex, truncateStyles } from 'components/common/styles'
import {
  PRIMARY_TEXT,
  BACKGROUND_REDESIGN,
  PURPLE,
  PURPLE_RGB,
} from 'constants/colors'

export const AddFilterButton = styled.span`
  color: ${PRIMARY_TEXT};
  font-size: 14px;
  font-weight: 500;
  line-height: 140%;
  width: 100px;
  text-align: center;
  padding: 8px 12px;
  cursor: pointer;
`

export const OtherFilterListItem = styled.li`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 0 16px;
  color: ${PRIMARY_TEXT};

  .MuiFormControl-fullWidth {
    width: auto;
    min-width: 300px;
    margin-left: 20px;

    .MuiOutlinedInput-input {
      padding: 10px;
    }
  }
`

export const UsersFilterButton = styled.div<{ isMenuOpen?: boolean }>`
  > button {
    border-radius: 8px;
    width: 240px;
    height: 36px;
    margin: 0 8px 0 10px;
    padding: 9px 12px;
    display: flex;
    justify-content: flex-start;
    cursor: pointer;
    background-color: ${({ isMenuOpen }) =>
      isMenuOpen ? css`rgba(${PURPLE_RGB}, 0.15)` : BACKGROUND_REDESIGN};
    color: ${({ isMenuOpen }) => (isMenuOpen ? PURPLE : PRIMARY_TEXT)};
    text-transform: capitalize;
    font-weight: 400;

    .MuiButton-label div {
      max-width: 200px;
      ${truncateStyles};
    }

    .MuiButton-endIcon {
      margin: 0 0 0 auto;
      transition: 0.3s;

      ${({ isMenuOpen }) =>
        isMenuOpen &&
        css`
          transform: rotate(180deg);
        `}
    }
  }
`

export const DatePickerContainer = styled(Flex)`
  > svg {
    position: absolute;
    margin-left: 20px;
    z-index: 1;
  }

  .MuiTextField-root {
    background-color: ${BACKGROUND_REDESIGN};
    border-radius: 8px;
    width: 240px;
    height: 36px;
    margin: 0 8px 0 10px;
    padding: 9px 12px;
    display: flex;
    justify-content: flex-start;
    cursor: pointer;
    color: ${PRIMARY_TEXT};

    input {
      padding: 0 0 0 22px;
    }

    .MuiInput-underline,
    .MuiInput-underline:hover {
      cursor: pointer;

      &:before {
        border-bottom: none;
      }

      &:after {
        display: none;
      }
    }
  }
`

export const FilterSelectContainer = styled.div`
  > div {
    width: 240px;
    margin: 0 8px 0 10px;
  }
`
